import { render, staticRenderFns } from "./SkeletonApplicantList.vue?vue&type=template&id=1f82fc60&"
import script from "./SkeletonApplicantList.vue?vue&type=script&lang=js&"
export * from "./SkeletonApplicantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SkeletonApplicantList.vue"
export default component.exports